import { Chip } from '@heroui/react';
import React from 'react';

import { TransmissionEvent } from '../types';

interface NewStateIndicatorProps {
  transmissionEvent: TransmissionEvent;
}

const getStateColor = (
  transmissionEvent: TransmissionEvent
): 'default' | 'success' | 'danger' | 'warning' => {
  if (transmissionEvent.isFailureEvent) {
    return 'danger';
  }
  if (transmissionEvent.isDeliveryEvent) {
    return 'success';
  }
  return 'default';
};

export const NewStateIndicator: React.FC<NewStateIndicatorProps> = ({
  transmissionEvent,
}) => {
  const color = getStateColor(transmissionEvent);

  return (
    <Chip size="sm" variant="flat" color={color}>
      {transmissionEvent.newState}
    </Chip>
  );
};
